import type { FieldConfig } from "./config"

export const countries = [
  { value: "us", label: "United States" },
  { value: "ca", label: "Canada" },
  { value: "uk", label: "United Kingdom" },
  { value: "au", label: "Australia" },
  { value: "in", label: "India" },
  { value: "jp", label: "Japan" },
  { value: "fr", label: "France" },
  { value: "de", label: "Germany" },
]

const productTypes = [
  { value: "9", label: "Forex Currency Notes", type: 'buy' },
  { value: "9", label: "Forex Currency Notes", type: 'sell' },
  { value: "36", label: "Forex Card", type: 'sell' },
  { value: "16", label: "Forex Card", type: 'buy' },
]

export const travelPurposes = [
  { value: "Education", label: "Education" },
  { value: "Tourism", label: "Tourism" },
  { value: "Business", label: "Business" },
]

const currenciesList = [
  { value: "usd", label: "USD" },
  { value: "eur", label: "EUR" },
  { value: "gbp", label: "GBP" },
  { value: "jpy", label: "JPY" },
  { value: "aud", label: "AUD" },
  { value: "cad", label: "CAD" },
]
export const customDestinationFields: FieldConfig[] = [
  {
    type: "select",
    name: "destination.purposeOfTravel",
    label: "Purpose of Travel",
    placeholder: "Select purpose of travel",
    options: travelPurposes,
    required: true,
    valueType: 'single_string'
  },
  {
    type: 'select',
    name: "destination.destination",
    label: "Where do you want to go? (Destination)",
    placeholder: "Search and select country",
    options: countries,
    required: true,
    valueType: 'single_string'
  },
  {
    type: "date",
    name: "destination.dateRange.start_date",
    label: "Journey Start Date",
    placeholder: "Select start date",
    required: false,
  },
  {
    type: "date",
    name: "destination.dateRange.end_date",
    label: "Journey End Date",
    placeholder: "Select end date",
    required: false,
  },
]

const cardTypes = [
  { value: "multicurrency", label: "Multi-Currency" },
  { value: "singlecurrency", label: "Single Currency" },
]

const forexProducts = [
  {
    value: 'sale',
    label: 'Sale'
  },
  {
    value: 'encashment',
    label: 'Encashment'
  },
]

export const productConfig: FieldConfig[] = [
  {
    type: 'select',
    name: 'product',
    label: '',
    options: forexProducts,
    required: true,
  },
  {
    type: 'select',
    name: 'productType',
    label: 'Select Product',
    options: productTypes,
    required: true,
  },
  {
    type: 'select',
    name: 'cardType',
    label: 'Select Card Type',
    options: cardTypes,
    required: false,
  },
  {
    type: 'select',
    name: 'currencies',
    label: 'Select Currencies*',
    options: currenciesList,
    required: true,
  },
]

export const customerConfig: FieldConfig[] = [
  {
    type: 'select',
    name: 'mobileNumber',
    label: 'What is the mobile number of customer?',
    options: [],
    required: true,
  },
  {
    type: 'text',
    name: 'fullName',
    label: 'What is the full name of the customer?',
    required: true,
  },
  {
    type: 'email',
    name: 'email',
    label: 'What is the email ID of the customer?',
    required: false,
  },
  {
    type: 'text',
    name: 'pan',
    label: "What is customer's PAN?",
    required: false,
  },
]

export const kycFileds : FieldConfig[] = [
  {
    type: 'file',
    name: 'kyc.pan',
    label: "Upload PAN",
    required: false,
  },
  {
    type: 'file',
    name: 'kyc.passportFront',
    label: "Upload Passport (Front)",
    required: false,
  },
  {
    type: 'file',
    name: 'kyc.passportBack',
    label: "Upload Passport (Back)",
    required: false,
  },
]

export const customerSingleConfig: FieldConfig[] = [
  {
    type: 'select',
    name: 'customers.0.mobileNumber',
    label: 'What is the mobile number of customer?',
    options: productTypes,
    required: true,
  },
  {
    type: 'text',
    name: 'customers.0.fullName',
    label: 'What is the full name of the customer?',
    required: true,
  },
  {
    type: 'email',
    name: 'customers.0.email',
    label: 'What is the email ID of the customer?',
    required: false,
  },
  {
    type: 'text',
    name: 'customers.0.pan',
    label: "What is customer's PAN?",
    required: false,
  },
]

type FormStep = 'forex' | 'visa' | 'travel'

export const step1: Record<FormStep, FieldConfig[]> = {
  'forex': customDestinationFields,
  'visa': customDestinationFields,
  'travel': customDestinationFields,
}

export const step2Singal: Record<FormStep, FieldConfig[]> = {
  'forex': customerSingleConfig,
  'visa': customerSingleConfig,
  'travel': customerSingleConfig,
}

export const step2: Record<FormStep, FieldConfig[]> = {
  'forex': customerConfig,
  'visa': customerConfig,
  'travel': customerConfig,
}

export const kycStep :Record<FormStep, FieldConfig[]> = {
  'forex': kycFileds,
  'visa': [],
  'travel': [],
}

export const products: Record<FormStep, FieldConfig[]> = {
  'forex': productConfig,
  'visa': productConfig,
  'travel': productConfig,
}
/* ------------------------------------------------------------------------
 * Declarations core needs on a forex order. Ops words: sale and encashment.
 * ---------------------------------------------------------------------- */

const yesNo = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
]

const isSale = (_values: any, mode: "sale" | "encashment") => mode === "sale"
const isEncashment = (_values: any, mode: "sale" | "encashment") => mode === "encashment"
const payerValue = (values: any): string => values?.declarations?.payerKind ?? "self"

/** Asked with the customer, on step 2. */
export const customerDeclarationFields: FieldConfig[] = [
  {
    type: "select",
    name: "declarations.residency",
    label: "Residency",
    placeholder: "Select residency",
    options: [
      { value: "resident", label: "Resident" },
      { value: "non_resident", label: "Non-resident" },
    ],
    required: true,
    valueType: "single_string",
  },
  {
    type: "select",
    name: "declarations.payerKind",
    label: "Paid by",
    placeholder: "Select who pays",
    options: [
      { value: "self", label: "Customer" },
      { value: "employer", label: "Employer" },
      { value: "sponsor", label: "Sponsor" },
      { value: "other", label: "Someone else" },
    ],
    valueType: "single_string",
    showIf: isSale,
  },
  {
    type: "select",
    name: "declarations.payerOrganizationId",
    label: "Paying company",
    placeholder: "Search and select company",
    options: [],
    valueType: "single_string",
    showIf: (values, mode) =>
      isSale(values, mode) && ["employer", "sponsor"].includes(payerValue(values)),
  },
  {
    type: "text",
    name: "declarations.payerName",
    label: "Payer's name",
    placeholder: "Name of the person or company paying",
    showIf: (values, mode) =>
      isSale(values, mode) && ["sponsor", "other"].includes(payerValue(values)),
  },
  {
    type: "select",
    name: "declarations.travellerDifferent",
    label: "Traveller is someone else",
    placeholder: "Select",
    options: yesNo,
    valueType: "single_string",
    showIf: isSale,
  },
  {
    type: "select",
    name: "declarations.travellerCustomerId",
    label: "Traveller",
    placeholder: "Search by mobile number",
    options: [],
    valueType: "single_string",
    showIf: (values, mode) =>
      isSale(values, mode) && values?.declarations?.travellerDifferent === "yes",
  },
]

/** Asked with the purpose and destination (sale) or on its own (encashment), on step 3. */
export const destinationDeclarationFields: FieldConfig[] = [
  {
    type: "number",
    name: "declarations.lrsDeclaredUsd",
    label: "Forex availed this year (USD)",
    placeholder: "0",
    min: 0,
    step: 1,
    showIf: isSale,
  },
  {
    type: "select",
    name: "declarations.lrsSigned",
    label: "LRS declaration signed",
    placeholder: "Select",
    options: yesNo,
    valueType: "single_string",
    showIf: isSale,
  },
  {
    type: "select",
    name: "declarations.sponsorEvidenceDocumentId",
    label: "Sponsor evidence",
    placeholder: "Select a document on file",
    options: [],
    valueType: "single_string",
    // Asked once, as "Paid by": an employer-paid trip is one where the employer is the payer.
    showIf: (values, mode) => isSale(values, mode) && payerValue(values) === "employer",
  },
  {
    type: "select",
    name: "declarations.declaredOnArrival",
    label: "Declared on arrival",
    placeholder: "Select",
    options: yesNo,
    valueType: "single_string",
    showIf: isEncashment,
  },
  {
    type: "select",
    name: "declarations.certificateRequested",
    label: "Certificate requested",
    placeholder: "Select",
    options: yesNo,
    valueType: "single_string",
    showIf: isEncashment,
  },
  {
    type: "select",
    name: "declarations.payoutMethod",
    label: "Payout method",
    placeholder: "Select payout method",
    options: [
      { value: "bank", label: "Bank" },
      { value: "cash", label: "Cash" },
    ],
    valueType: "single_string",
    showIf: isEncashment,
  },
]

/** Asked with delivery, on the last step. A sale only: an encashment pays out. */
export const paymentDeclarationFields: FieldConfig[] = [
  {
    type: "select",
    name: "declarations.paymentMode",
    label: "Payment mode",
    placeholder: "Select payment mode",
    options: [
      { value: "cash", label: "Cash" },
      { value: "cheque", label: "Cheque" },
      { value: "eft", label: "Bank transfer" },
      { value: "dd", label: "Demand draft" },
      { value: "upi", label: "UPI" },
      { value: "card", label: "Card" },
    ],
    valueType: "single_string",
    showIf: isSale,
  },
  {
    type: "text",
    name: "declarations.instrumentRef",
    label: "Bank reference / UTR",
    placeholder: "Cheque, draft or transfer number",
    showIf: (values, mode) =>
      isSale(values, mode) &&
      !!values?.declarations?.paymentMode &&
      values.declarations.paymentMode !== "cash",
  },
  {
    type: "number",
    name: "declarations.cashAmount",
    label: "Cash amount (INR), within the cash limit",
    placeholder: "Defaults to the whole bill",
    min: 0,
    step: 1,
    showIf: (values, mode) => isSale(values, mode) && values?.declarations?.paymentMode === "cash",
  },
]
